.bn{flex-shrink:0;}